__turbopack_context__.v({
  "cta": "NUpCta-module__p9HgsW__cta",
  "nUpCtaDesktop": "NUpCta-module__p9HgsW__nUpCtaDesktop",
  "nUpCtaMobile": "NUpCta-module__p9HgsW__nUpCtaMobile",
});
